/* tslint:disable */
/* eslint-disable */
/**
 * Kontor API
 * OpenAPI specification for Kontor application framework
 *
 * The version of the OpenAPI document: 1.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    EventAttributesExternalTicketAgency,
    EventAttributesExternalTicketAgencyFromJSON,
    EventAttributesExternalTicketAgencyFromJSONTyped,
    EventAttributesExternalTicketAgencyToJSON,
} from './EventAttributesExternalTicketAgency';
import {
    EventAttributesFreeText,
    EventAttributesFreeTextFromJSON,
    EventAttributesFreeTextFromJSONTyped,
    EventAttributesFreeTextToJSON,
} from './EventAttributesFreeText';
import {
    EventAttributesReservations,
    EventAttributesReservationsFromJSON,
    EventAttributesReservationsFromJSONTyped,
    EventAttributesReservationsToJSON,
} from './EventAttributesReservations';
import {
    EventAttributesTicketing,
    EventAttributesTicketingFromJSON,
    EventAttributesTicketingFromJSONTyped,
    EventAttributesTicketingToJSON,
} from './EventAttributesTicketing';

/**
 * All object attributes
 * @export
 * @interface EventAttributes
 */
export interface EventAttributes {
    /**
     * Agenda items
     * @type {Array<object>}
     * @memberof EventAttributes
     */
    agenda?: Array<object>;
    /**
     * Headline text
     * @type {string}
     * @memberof EventAttributes
     */
    headline?: string;
    /**
     * Highlight as tip
     * @type {boolean}
     * @memberof EventAttributes
     */
    tip?: boolean;
    /**
     * Event type
     * @type {string}
     * @memberof EventAttributes
     */
    type?: string;
    /**
     * Additional text labels to group different events
     * @type {Array<object>}
     * @memberof EventAttributes
     */
    labels?: Array<object>;
    /**
     * Doors opening at date/time
     * @type {Date}
     * @memberof EventAttributes
     */
    doorsOpening?: Date;
    /**
     * Show starts at date/time
     * @type {Date}
     * @memberof EventAttributes
     */
    showtime?: Date;
    /**
     * Break starts at date/time
     * @type {Date}
     * @memberof EventAttributes
     */
    breakBegin?: Date;
    /**
     * Break ends at date/time
     * @type {Date}
     * @memberof EventAttributes
     */
    breakEnd?: Date;
    /**
     * Show ends at date/time
     * @type {Date}
     * @memberof EventAttributes
     */
    end?: Date;
    /**
     * Date of event
     * @type {Date}
     * @memberof EventAttributes
     */
    date?: Date;
    /**
     * End date for exhibition-type events
     * @type {Date}
     * @memberof EventAttributes
     */
    dateTo?: Date;
    /**
     * 
     * @type {EventAttributesFreeText}
     * @memberof EventAttributes
     */
    freeText?: EventAttributesFreeText;
    /**
     * Admission options as unstructured text
     * @type {string}
     * @memberof EventAttributes
     */
    admission?: string;
    /**
     * 
     * @type {EventAttributesTicketing}
     * @memberof EventAttributes
     */
    ticketing?: EventAttributesTicketing;
    /**
     * 
     * @type {EventAttributesExternalTicketAgency}
     * @memberof EventAttributes
     */
    externalTicketAgency?: EventAttributesExternalTicketAgency;
    /**
     * 
     * @type {EventAttributesReservations}
     * @memberof EventAttributes
     */
    reservations?: EventAttributesReservations;
    /**
     * Contact tracing active
     * @type {boolean}
     * @memberof EventAttributes
     */
    contactTracing?: boolean;
    /**
     * Facebook-ID for events published on Facebook
     * @type {string}
     * @memberof EventAttributes
     */
    facebookID?: string;
    /**
     * Event location ID
     * @type {number}
     * @memberof EventAttributes
     */
    locationId?: number;
    /**
     * Master event ID. Events with several showings share the same master event ID.
     * @type {number}
     * @memberof EventAttributes
     */
    masterEventId?: number;
    /**
     * Event description
     * @type {string}
     * @memberof EventAttributes
     */
    description?: string;
    /**
     * Short event description text
     * @type {string}
     * @memberof EventAttributes
     */
    shortDescription?: string;
    /**
     * List of all event images
     * @type {Array<object>}
     * @memberof EventAttributes
     */
    images?: Array<object>;
}

export function EventAttributesFromJSON(json: any): EventAttributes {
    return EventAttributesFromJSONTyped(json, false);
}

export function EventAttributesFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventAttributes {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'agenda': !exists(json, 'agenda') ? undefined : json['agenda'],
        'headline': !exists(json, 'headline') ? undefined : json['headline'],
        'tip': !exists(json, 'tip') ? undefined : json['tip'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'labels': !exists(json, 'labels') ? undefined : json['labels'],
        'doorsOpening': !exists(json, 'doorsOpening') ? undefined : (new Date(json['doorsOpening'])),
        'showtime': !exists(json, 'showtime') ? undefined : (new Date(json['showtime'])),
        'breakBegin': !exists(json, 'breakBegin') ? undefined : (new Date(json['breakBegin'])),
        'breakEnd': !exists(json, 'breakEnd') ? undefined : (new Date(json['breakEnd'])),
        'end': !exists(json, 'end') ? undefined : (new Date(json['end'])),
        'date': !exists(json, 'date') ? undefined : (new Date(json['date'])),
        'dateTo': !exists(json, 'dateTo') ? undefined : (new Date(json['dateTo'])),
        'freeText': !exists(json, 'freeText') ? undefined : EventAttributesFreeTextFromJSON(json['freeText']),
        'admission': !exists(json, 'admission') ? undefined : json['admission'],
        'ticketing': !exists(json, 'ticketing') ? undefined : EventAttributesTicketingFromJSON(json['ticketing']),
        'externalTicketAgency': !exists(json, 'externalTicketAgency') ? undefined : EventAttributesExternalTicketAgencyFromJSON(json['externalTicketAgency']),
        'reservations': !exists(json, 'reservations') ? undefined : EventAttributesReservationsFromJSON(json['reservations']),
        'contactTracing': !exists(json, 'contactTracing') ? undefined : json['contactTracing'],
        'facebookID': !exists(json, 'facebookID') ? undefined : json['facebookID'],
        'locationId': !exists(json, 'locationId') ? undefined : json['locationId'],
        'masterEventId': !exists(json, 'masterEventId') ? undefined : json['masterEventId'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'shortDescription': !exists(json, 'shortDescription') ? undefined : json['shortDescription'],
        'images': !exists(json, 'images') ? undefined : json['images'],
    };
}

export function EventAttributesToJSON(value?: EventAttributes | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'agenda': value.agenda,
        'headline': value.headline,
        'tip': value.tip,
        'type': value.type,
        'labels': value.labels,
        'doorsOpening': value.doorsOpening === undefined ? undefined : (value.doorsOpening.toISOString()),
        'showtime': value.showtime === undefined ? undefined : (value.showtime.toISOString()),
        'breakBegin': value.breakBegin === undefined ? undefined : (value.breakBegin.toISOString()),
        'breakEnd': value.breakEnd === undefined ? undefined : (value.breakEnd.toISOString()),
        'end': value.end === undefined ? undefined : (value.end.toISOString()),
        'date': value.date === undefined ? undefined : (value.date.toISOString().substr(0,10)),
        'dateTo': value.dateTo === undefined ? undefined : (value.dateTo.toISOString().substr(0,10)),
        'freeText': EventAttributesFreeTextToJSON(value.freeText),
        'admission': value.admission,
        'ticketing': EventAttributesTicketingToJSON(value.ticketing),
        'externalTicketAgency': EventAttributesExternalTicketAgencyToJSON(value.externalTicketAgency),
        'reservations': EventAttributesReservationsToJSON(value.reservations),
        'contactTracing': value.contactTracing,
        'facebookID': value.facebookID,
        'locationId': value.locationId,
        'masterEventId': value.masterEventId,
        'description': value.description,
        'shortDescription': value.shortDescription,
        'images': value.images,
    };
}

